/**
 * Resolve quote line unitPrice/total for invoice forms.
 * 0 is a valid free / included price. Only blank values are missing.
 */

export function isBlankMoney(value) {
  return value === null || value === undefined || value === "";
}

export function parseMoneyField(value) {
  if (isBlankMoney(value)) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}

export function resolveQuoteItemPricing(item, context = {}) {
  const quantity = Number(item?.quantity) > 0 ? Number(item.quantity) : 1;
  const explicitUnit = parseMoneyField(item?.unitPrice);
  const explicitTotal = parseMoneyField(item?.total);
  let unitPrice = explicitUnit;
  let total = explicitTotal;

  if (total != null && unitPrice == null) {
    unitPrice = total / quantity;
  } else if (unitPrice != null && total == null) {
    total = unitPrice * quantity;
  } else if (unitPrice == null && total == null) {
    const fallback = parseMoneyField(context.quoteTotal) ?? 0;
    const divisor =
      Number(context.quoteItemCount) > 0 ? Number(context.quoteItemCount) : 1;
    unitPrice = fallback / divisor;
    total = unitPrice * quantity;
  }

  return {
    quantity,
    unitPrice: Math.round(unitPrice * 100) / 100,
    total: Math.round(total * 100) / 100,
    hasExplicitPricing: explicitUnit != null || explicitTotal != null,
  };
}
